export default __webpack_public_path__ + "static/media/Snd1.e8e4e6b5.mp3";